import {
  getSchema as getSchema1,
  uiSchema as uiSchema1,
} from "./schema.shareDocumentMessage.1";
import { IExtraData } from "./schema.shareDocumentMessage.types";
import { getInitialValues } from "./schema.shareDocumentMessage.utils";

// eslint-disable-next-line import/no-default-export
export default (extraData: IExtraData) => {
  const initialValues = getInitialValues(extraData);
  return [
    {
      schema: getSchema1(initialValues, extraData),
      uiSchema: uiSchema1(extraData),
    },
  ];
};
